import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fnw2e7p4xp: FaireBrandEntity = {
  token: "b_fnw2e7p4xp",
  type: "brand",
  name: "BRVE by Fletch",
  avatarUrl:
    "https://cdn.faire.com/fastly/d4cd1ec2c033aa922bb5751e8ec1e0393e6d626e1d24ff226b26f8832e253e2e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/eb260099866e6b0060c8223a99bd5f4649f0ac241c9963d432820ea425d5cb6c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d4cd1ec2c033aa922bb5751e8ec1e0393e6d626e1d24ff226b26f8832e253e2e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/eb260099866e6b0060c8223a99bd5f4649f0ac241c9963d432820ea425d5cb6c.png",
  location: "Frisco, TX, USA",
  minimumOrderDollars: 250,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "BRVE exists to raise up a generation of children who shine boldly for Jesus. Born from a season of deep surrender and miraculous encounters with the Lord, BRVE faithwear is more than pajamas—it's a daily declaration of faith, courage, and kingdom purpose.\n\nWe create faith-filled designs that wrap children in truth, speak life over families, and inspire parents to raise lights in a dark world. In the wake of profound personal loss, BRVE is the heartbeat of a single mom on a mission—to advance the kingdom of God through the next generation, one bedtime, one child, one promise at a time.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:55.523Z",
    importedBy: "entity-db-cli",
  },
};
